import merge from 'lodash/merge';

import './image.control';
import './image.control.less';
import template from './image.control.html';

export function binaryStringToFile(content, fileName: string, fileType: string): File {
    const ui8 = new Uint8Array(content.length);

    for (let i = 0; i < content.length; ++i) {
        ui8[i] = content.charCodeAt(i);
    }

    return new File([ui8], fileName, { type: fileType });
}

export function mergeDirectiveOptions(options) {
    return merge(
        {},
        {
            scope: {
                state: '=?',
                onReady: '&',
                image: '<?',
                maxWeight: '<?',
                imageName: '<?',
                imageSize: '@?',
                shape: '<?',
                actions: '<?'
            },
            replace: true,
            template() {
                return template;
            }
        },
        options
    );
}

export * from './image.control';
